import React from "react";
import ReactDOM from "react-dom/client";
import { StyleSheetManager } from "styled-components";
import "./bootstrap.min.css";
import "./index.css";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import setupAxios from "./setupAxios";
import "./components/Header";
import "./components/Footer";
import "./components/Header";
import "bootstrap/dist/css/bootstrap.min.css";

setupAxios(); // アプリケーション起動時にAxiosの設定を適用

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <StyleSheetManager shouldForwardProp={(prop) => prop !== "selected"}>
      <App />
    </StyleSheetManager>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
